import React from "react";
import { Description as DialogPrimitiveDescription } from "@radix-ui/react-dialog";
import PropTypes from "prop-types";
import { twMerge } from "tailwind-merge";
import cc from "classcat";
ModalContent.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string
};
export default function ModalContent(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ React.createElement(DialogPrimitiveDescription, {
        asChild: true
    }, /*#__PURE__*/ React.createElement("div", {
        className: twMerge(cc([
            "mb-7 w-full flex-grow px-8 dark:border-gray-700 dark:text-gray-200",
            className
        ]))
    }, children));
}
